// 取得登入者某功能的權限
function getFunctionPermission (functionCode) {
  var FUNCTION = JSON.parse(localStorage.getItem('FUNCTION'))
  var functionPermission = 0
  FUNCTION.forEach(function (arrRole, Index) {
    if (arrRole.functionCode === functionCode && arrRole.functionPermission > 0) {
      functionPermission = arrRole.functionPermission
    }
  })
  // console.log(JSON.parse(localStorage.getItem('FUNCTION')))
  // console.log('functionPermission:' + functionPermission)
  return functionPermission
}
export { // 很关键
  getFunctionPermission
}



// WEBPACK FOOTER //
// ./src/js/LoginUserFunction.js